

















import { Component, Prop, Vue } from "vue-property-decorator";
import {
  IBlackListRule,
  IWhiteListRule,
} from "@/modules/Segmentation/models/SegmentationRules";
import StringArrayForm from "@/components/StringArrayForm.vue";
import AddressSearchForm from "@/components/AddressSearchForm.vue";
import { Address } from "@/models/Address";

const isWhiteList = (
  obj: IWhiteListRule | IBlackListRule,
): obj is IWhiteListRule => {
  return obj.hasOwnProperty("whiteList");
};

@Component({
  components: { AddressSearchForm, StringArrayForm },
})
export default class StringArrayFormInvertible extends Vue {
  @Prop() public readonly label!: string;
  @Prop() public readonly blackListHint?: string;
  @Prop() public readonly whiteListHint?: string;
  @Prop() public readonly blackListSwitchLabel?: string;
  @Prop() public readonly whiteListSwitchLabel?: string;
  @Prop() public readonly ruleAddresses!: Address[];
  @Prop() public readonly value!: IWhiteListRule | IBlackListRule;

  get switchLabel(): string {
    let res: string;

    if (isWhiteList(this.value)) {
      if (this.value.isException) {
        res = this.blackListSwitchLabel || "";
      } else {
        res = this.whiteListSwitchLabel || "";
      }
    } else {
      if (this.value.isException) {
        res = this.whiteListSwitchLabel || "";
      } else {
        res = this.blackListSwitchLabel || "";
      }
    }

    return res;
  }

  get hint(): string {
    let res: string;

    if (isWhiteList(this.value)) {
      if (this.value.isException) {
        res = this.blackListHint || "";
      } else {
        res = this.whiteListHint || "";
      }
    } else {
      if (this.value.isException) {
        res = this.whiteListHint || "";
      } else {
        res = this.blackListHint || "";
      }
    }

    return res;
  }
}
